module.exports = __webpack_public_path__ + "media/images/icons/material/star-circle-258d1f662a3cbecdf16e1ad9fb0e616c.svg";